// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Loader$OrcaPaymentPage from "./Loader.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";

function close(setOpenModal) {
  setOpenModal(param => false);
  setTimeout(() => Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
      "fullscreen",
      false
    ]]), 450);
}

function Modal(props) {
  let openModal = props.openModal;
  let setOpenModal = props.setOpenModal;
  let __testMode = props.testMode;
  let __showClose = props.showClose;
  let __loader = props.loader;
  let closeCallback = props.closeCallback;
  let __loader_value = __loader !== undefined ? __loader : false;
  let __showClose_value = __showClose !== undefined ? __showClose : true;
  let __testMode_value = __testMode !== undefined ? __testMode : true;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match.themeObj;
  let closeModal = () => {
    setOpenModal(param => false);
    if (closeCallback !== undefined) {
      return closeCallback();
    } else {
      setTimeout(() => Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "fullscreen",
          false
        ]]), 450);
      return;
    }
  };
  React.useEffect(() => {
    if (__loader_value) {
      setOpenModal(param => false);
    } else {
      setOpenModal(param => true);
    }
  }, [__loader_value]);
  let loaderVisibility = __loader_value ? "visible" : "hidden";
  let contentVisibility = React.useMemo(() => {
    if (openModal) {
      return "visible";
    } else {
      return "hidden";
    }
  }, [openModal]);
  let marginTop = __testMode_value ? "mt-8" : "mt-6";
  let animate = contentVisibility === "visible" ? "animate-zoomIn" : "animate-zoomOut";
  let loaderUI = JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Loader$OrcaPaymentPage.make, {
      showText: false
    }),
    className: `flex justify-center m-auto ` + loaderVisibility
  });
  return JsxRuntime.jsxs("div", {
    children: [
      loaderUI,
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
                condition: __testMode_value && !isProductionEnv,
                children: JsxRuntime.jsx("div", {
                  children: "TEST DATA",
                  className: "w-full h-6 text-[#885706] bg-[#FDD486] text-xs flex justify-center items-center font-semibold"
                })
              }),
              JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
                condition: __showClose_value,
                children: JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
                    name: "cross",
                    size: 23
                  }),
                  className: "p-4 flex justify-end self-end mb-4 cursor-pointer",
                  onClick: param => closeModal()
                })
              })
            ],
            className: "absolute top-0 left-0 w-full flex flex-col"
          }),
          JsxRuntime.jsx("div", {
            children: props.children,
            className: `mt-12 sm:` + marginTop
          })
        ],
        className: `w-full h-full sm:h-auto sm:w-[55%] md:w-[45%] lg:w-[35%] xl:w-[32%] 2xl:w-[27%]  m-auto bg-white flex flex-col justify-start sm:justify-center px-5 pb-5 md:pb-6 pt-4 md:pt-7 rounded-none sm:rounded-md relative overflow-scroll ` + animate,
        style: {
          backgroundColor: themeObj.colorBackground === "transparent" ? "" : Utils$OrcaPaymentPage.rgbaTorgb(themeObj.colorBackground),
          opacity: openModal ? "100" : "0",
          transition: "opacity .35s ease .1s,transform .35s ease .1s,-webkit-transform .35s ease .1s"
        }
      })
    ],
    className: "h-screen w-screen bg-black/40 flex m-auto items-center backdrop-blur-sm overflow-scroll",
    style: {
      opacity: openModal ? "100" : "0",
      transition: "opacity .35s ease .1s,background-color 600ms linear"
    }
  });
}

let make = Modal;

export {
  close,
  make,
}
/* jotai Not a pure module */
